var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 0.00683594H2.0013C1.26797 0.00683594 0.667969 0.606836 0.667969 1.34017V4.00017H2.0013V1.32684H14.0013V10.6802H2.0013V8.00017H0.667969V10.6735C0.667969 11.4068 1.26797 11.9935 2.0013 11.9935H14.0013C14.7346 11.9935 15.3346 11.4068 15.3346 10.6735V1.34017C15.3346 0.986547 15.1942 0.647409 14.9441 0.39736C14.6941 0.147312 14.3549 0.00683594 14.0013 0.00683594ZM7.33464 8.66684L10.0013 6.00017L7.33464 3.3335V5.3335H0.667969V6.66684H7.33464V8.66684Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationPlace);
export default __webpack_public_path__ + "static/media/ApplicationPlace.25fa0b04ee3e56104b473aa8b20fded4.svg";
export { ForwardRef as ReactComponent };